<template>
  <div class="sideBar">
    <div class="flex-center-y pb-4">
      <span @click="close" class="switcher"></span>
      <span class="logo"></span>
    </div>

    <div class="flex h-9">
      <span @click="$router.push('/deposito')" class="deposito"></span>
      <span @click="handleSaqueClick($router)" class="saque">{{ t('home.SideBar.Saque') }}</span>
    </div>

    <Tab v-for="(item, index) in tabs" :key="index" :item="item" class="mt-2">
      <template #title>
        <div class="flex-between bg-[#2C795226] p-[8px_16px] rounded-8" @click="item.handleTitleClick?.(item)">
          <div class="flex-center-y">
            <component :is="item.icon" class="size-6 mr-3" />
            {{ item.title }}
          </div>

          <img v-if="item.content?.length" :src="item.opened ? bn_close : bn_open" class="size-6"/>
        </div>
      </template>

      <div v-if="item.content?.length" class="pb-2 overflow-x-auto flex flex-wrap">
        <div v-for="c in item.content" class="tabItem" :class="c.showRedPoint ? 'withRedPoint' : ''" @click="item.handleClick?.(c)">
          <Image :src="c.icon" class="size-9">
            <template #loading>
              <van-loading type="spinner" size="20" />
            </template>
          </Image>
          <div class="mt-1 truncate w-full text-center">{{ c.title }}</div>
        </div>
      </div>
    </Tab>

    <div class="text-11 text-white flex-center-y py-7">
      <img
        src="/static/images/18age.png"
        class="size-7 mr-3"
      />
      {{ t('home.SideBar.Direitos') }}
    </div>
  </div>
</template>

<script setup lang="tsx">
  import Tab from './tab.vue'
  import { useActivityList, useGameCategory, useSystemInfo } from '@/store'
  import { gotoActivity, gotoGameCategory } from '@/utils'
  import { useHomeBannersAndTexts } from '@/store'

  import i_casa from '@a/views/Home/images/i_casa.png'
  import i_promoca from '@a/views/Home/images/i_promoca.png'
  // import i_rasp from '@a/views/Home/images/i_rasp.png'
  import i_meus from '@a/views/Home/images/i_meus.png'
  import i_configure from '@a/views/Home/images/i_configure.png'
  import i_agente_c from '@a/views/Home/images/i_agente_c.png'
  import i_oficial from '@a/views/Home/images/i_oficial.png'
  import i_lang from '@a/assets/images/i_lang.png'
  import bn_open from '@a/views/Home/images/bn_open.png'
  import bn_close from '@a/views/Home/images/bn_close.png'
  import l_br from '@a/assets/images/lang_br.png'
  import l_br_gray from '@a/assets/images/lang_br_gray.png'
  import l_en from '@a/assets/images/lang_en.png'
  import l_en_gray from '@a/assets/images/lang_en_gray.png'

  import { handleSaqueClick } from "@/utils/userStatusUtils";
  import i18n from "@/i18n";
  const t = i18n.global.t;

  defineProps<{
    close: () => void
  }>()

  const router = useRouter()

  const gameCategories = computed(() => useGameCategory().leftList)
  const categories = computed(() => gameCategories.value.map(item => ({
    ...item,
    icon: item.customIcon || item.defaultIcon || item.icon,
    title: item.customName || item.name,
  })))

  const activityList = computed(() => useActivityList().activityList.map(item => ({
    icon: item.menuLogo,
    title: item.activityConfigLogo,
    ...item
  })))

  // const emit = defineEmits(['close'])

  interface iTabItem {
    title: string
    icon: any
    opened: boolean
    content?: any
    handleClick?: (item: any) => void
    handleTitleClick?: (item: any) => void
  }

  const mediaList = computed(() => useHomeBannersAndTexts().socialMedia)

  const langList = computed(() => {
    const l = useSystemInfo().language
    const ls = useSystemInfo().languages
    const br = l == 'pt' ? l_br : l_br_gray
    const en = l == 'en' ? l_en : l_en_gray
    return ls.map(item => ({
      title: item == 'pt' ? 'Português' : 'English',
      icon: item == 'pt' ? br : en,
      lang: item,
    }))
  })

  const tabs = ref<iTabItem[]>([
    {
      title: t('home.SideBar.CasaDeJogos'),
      icon: <img src={ i_casa } alt="" />,
      opened: false,
      content: categories,
      handleClick: item => {
        gotoGameCategory(item, router)
      }
    },
    {
      title: t('home.SideBar.Promocoes'),
      icon: <img src={ i_promoca } alt="" />,
      opened: false,
      content: activityList,
      handleClick: (item) => {
        gotoActivity(item, router)
      }
    },
    // {
    //   title: 'Raspadinha',
    //   icon: <img src={ i_rasp } alt="" />,
    //   opened: false,
    //   handleTitleClick: () => {
    //     router.push('/ggl')
    //   }
    // },
    {
      title: t('home.SideBar.MeusRelatorios'),
      icon: <img src={ i_meus } alt="" />,
      opened: false,
      handleTitleClick: () => {
        router.push('/registro')
      }
    },
    {
      title: t('home.SideBar.Configuracao'),
      icon: <img src={ i_configure } alt="" />,
      opened: false,
      handleTitleClick: () => {
        router.push('/profile')
      }
    },
    {
      title: t('home.SideBar.CentroDeAgentes'),
      icon: <img src={ i_agente_c } alt="" />,
      opened: false,
      handleTitleClick: () => {
        const agentcenter = activityList.value.find(item => item.linkName === 'agentcenter')
        gotoActivity(agentcenter, router)
      }
    },
    {
      title: t('home.SideBar.CanalOficial'),
      icon: <img src={ i_oficial } alt="" />,
      opened: false,
      content: mediaList.value.map(item => ({
        ...item,
        icon: item.customIcon || `local://${item.mediaType}.png`,
        title: item.mediaType,
      })).filter(item => item.title != '18'),
      handleClick: (item: any) => {
        if (item.hyperlink) window.open(item.hyperlink);
      }
    },
    {
      title: t('home.SideBar.Lingua'),
      icon: <img src={ i_lang } alt="" />,
      opened: false,
      content: langList,
      handleClick: (item: any) => {
        useSystemInfo().setLanguage(item.lang)
      }
    }
  ])
</script>

<style lang="scss">
.sideBar{
  @apply p-4 text-white contain-layout;

  .switcher{
    @apply size-6 mr-1.5 bg-[var(--theme-primary)] rotate-180;

    -webkit-mask: url('@a/views/Home/images/arrow_right.png') no-repeat center bottom / 100% auto;
    mask: url('@a/views/Home/images/arrow_right.png') no-repeat center bottom / 100% auto;
  }

  .logo{
    @apply w-29.5 h-6.5 bgs-[url('@/assets/logo.png')];
  }

  .deposito{
    @apply w-37.5 h-9 bgs-[url('@a/views/Home/images/bn_deposito.png')];
  }

  .saque{
    @apply w-22.5 h-9 bgs-[url('@a/views/Home/images/bn_saque.png')] text-center leading-36 text-[var(--theme-primary)] text-11;
  }

  .van-collapse-item--border:after{
    @apply hidden;
  }

  .tabItem{
    @apply flex-center-col bd-[1px_#FFFFFF40] mr-[15px] mt-4 size-[70px] rounded-8;

    &:nth-child(3n){
      @apply mr-0;
    }
  }
}
</style>
